export const convertMemberFsAdminForToIds = (filespaceAdminFor) => {
    if (filespaceAdminFor === 'all' || !filespaceAdminFor) {
        return [];
    }
    return filespaceAdminFor.map((entry) => entry.filespaceId);
};
export const ensureArrayOfIds = (entity) => {
    if (typeof entity === 'object' &&
        typeof entity !== 'function' &&
        !Array.isArray(entity) &&
        entity !== null) {
        return Object.keys(entity);
    }
    return entity;
};
export const getManagedFilespaceIdsDifference = ({ managedFilespaceIds, prevManagedFilespaceIds, }) => {
    // In all the cases that we're dependant on values being 'all' we DO NOT account them towards the UI at the moment.
    // Deriving from the above sentence it is assumed that the transition between "all" states are based on the role itself.
    if (managedFilespaceIds === 'all' || prevManagedFilespaceIds === 'all') {
        return {
            grantedFsIds: [],
            demotedFsIds: [],
            haveManagedFilespacesChanged: false,
        };
    }
    // Covering the use case where info from the SDK is directly passed.
    managedFilespaceIds = ensureArrayOfIds(managedFilespaceIds);
    prevManagedFilespaceIds = ensureArrayOfIds(prevManagedFilespaceIds);
    const grantedFsIds = managedFilespaceIds.filter((managedFilespaceId) => !prevManagedFilespaceIds.includes(managedFilespaceId));
    const demotedFsIds = prevManagedFilespaceIds.filter((prevManagedFilespaceId) => !managedFilespaceIds.includes(prevManagedFilespaceId));
    return {
        grantedFsIds,
        demotedFsIds,
        haveManagedFilespacesChanged: Boolean(grantedFsIds.length || demotedFsIds.length),
    };
};
